// extracted by mini-css-extract-plugin
export var heading = "styles-module--heading--757f1";
export var highlight = "styles-module--highlight--ef87a";
export var modal = "styles-module--modal--d3fea";
export var selected = "styles-module--selected--befb1";